var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{attrs:{"id":"modal-omploop","size":"xl","title":"Pilih Omploop","hide-footer":"","body-class":"pt-0"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('Table',{attrs:{"purpose":"modal-omploop","selectedItem":_vm.selectedItem,"checkbox":_vm.checkbox},on:{"chooseEmployee":_vm.chosenEmployee}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }